export enum ProductTaskTypeEnum {
  ISSUE = 'issue',
  STORY = 'story',
  TASK = 'task',
}
